// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FHeC1JkdTAOW_Ev91jpa{display:inline-flex;align-items:center;justify-content:center;background-color:#f5f5f5;border-radius:6px}`, "",{"version":3,"sources":["webpack://./src/brands/dentistry-one/Components/BrandLogo/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,mBAAA,CACA,kBAAA,CACA,sBAAA,CACA,wBAAA,CACA,iBAAA","sourcesContent":[".customLogoBackdrop {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f5f5f5;\n  border-radius: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customLogoBackdrop": `FHeC1JkdTAOW_Ev91jpa`
};
export default ___CSS_LOADER_EXPORT___;
